import { IIcd10CodesStore } from './types';

const initStore: IIcd10CodesStore = {
  items: [],
  pagination: {
    page: 0,
    itemsPerPage: 20,
    hasMore: false,
  },
};

export default initStore;
